import React from 'react';
import {
  Bot,
  BrainCircuit,
  MessageCircle,
  CalendarCheck,
  Repeat,
  BellRing,
  BedDouble,
  CalendarClock,
  ShieldCheck,
  KeyRound,
  Star,
  Sparkles,
} from 'lucide-react';

const iconMap = {
  Bot,
  BrainCircuit,
  MessageCircle,
  CalendarCheck,
  Repeat,
  BellRing,
  BedDouble,
  CalendarClock,
  ShieldCheck,
  KeyRound,
  Star,
  Sparkles,
};

const ServiceIcon = ({ icon, className = 'w-7 h-7' }) => {
  const IconComponent = iconMap[icon] || Bot;
  return <IconComponent className={className} />;
};

export default ServiceIcon;
